module.exports = __webpack_public_path__ + "media/packs/compcalc/components/images/under-construction-109bdc97d024b17d0d40296e3fac6d10.png";